// extracted by mini-css-extract-plugin
module.exports = {"root":"App-root-3Hk1g","tabContent":"App-tabContent-1HCwb"};